import { render } from "./PageSection.vue?vue&type=template&id=ead4c842&scoped=true"
import script from "./PageSection.vue?vue&type=script&lang=js"
export * from "./PageSection.vue?vue&type=script&lang=js"

import "./PageSection.vue?vue&type=style&index=0&id=ead4c842&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ead4c842"]])

export default __exports__